import getLang from '../../../utils/getLang';
import useSearchParams from '../../../hooks/useSearchParams';
import OverviewModal from './OverviewModal';
import { jsx as _jsx } from "react/jsx-runtime";
const OverviewModalRouter = () => {
  const [{
    overviewType,
    overviewEntityId,
    overviewLanguage,
    overviewSource
  }] = useSearchParams();
  if (overviewType && overviewEntityId && !isNaN(Number(overviewEntityId))) {
    var _ref;
    return /*#__PURE__*/_jsx(OverviewModal, {
      entityId: Number(overviewEntityId),
      language: (_ref = overviewLanguage) !== null && _ref !== void 0 ? _ref : getLang(),
      source: overviewSource,
      type: overviewType
    });
  }
  return null;
};
export default OverviewModalRouter;